module.exports = __webpack_public_path__ + "static/media/aktuell.d8310fd9.svg";